import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import StatutoryReportFieldService from "../../services/StatutoryReportFieldService";
import { showLoader,removeLoader } from "deskera-ui-library";

const initialState = {
    data: {},
};

export const fetchProfessionalTaxDetails = createAsyncThunk("ptReport", async () => {
  showLoader()
    const response = await StatutoryReportFieldService.getProfessionalTaxReport();
  removeLoader()
    return response;
  });

  
  export const StatutoryReportSlice = createSlice({
      name: 'statutoryReport',
      initialState,
      reducers: {
         
      },
      extraReducers: (builder) => {
          builder
            .addCase(fetchProfessionalTaxDetails.pending, (state) => {
              state.status = "loading";
            })
            .addCase(fetchProfessionalTaxDetails.fulfilled, (state, action) => {
              state.status = "idle";
              state.data = action.payload;
            })
      }
  });


export const selectProfessionalTaxReportDetails = (state) => {
    return state.statutoryReport.data;
  };

export default StatutoryReportSlice.reducer;